function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { createContext, useContext, useMemo } from 'react';
import { isAssigned, isFunction } from '@okee-uikit/react-utils';
import { useSelectionMultiple, useSelectionSingle } from '@okee-uikit/react-hooks';
import { Radio } from '../../radio';
import { Checkbox } from '../../checkbox';
import { Switch } from '../../switch';
import { SELECTION_COLUMN_ID } from '../constants';
import { TableSelectionHeader } from '../atom/features';
import { useClearTableColumn } from '../col-query/column-info';
var COLUMN_WIDTH_CHECKER = 48;
var COLUMN_WIDTH_CHECKER_DROPDOWN = 56;
var COLUMN_WIDTH_SWITCH = 60;
export function useTableSelectionInit(options) {
  var enable = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : isAssigned(options);

  var _ref = options || {},
      value = _ref.value,
      defaultValue = _ref.defaultValue,
      onChange = _ref.onChange,
      controlled = _ref.controlled,
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? 'multiple' : _ref$type,
      component = _ref.component,
      _ref$dropdownMenu = _ref.dropdownMenu,
      dropdownMenu = _ref$dropdownMenu === void 0 ? false : _ref$dropdownMenu;

  var _ref2 = options || {},
      onDiff = _ref2.onDiff;

  var selectionOptions = {
    value: value,
    defaultValue: defaultValue,
    onChange: onChange,
    controlled: controlled,
    onDiff: onDiff
  };

  var _useSelectionMultiple = useSelectionMultiple(type === 'multiple' && selectionOptions || {}),
      _useSelectionMultiple2 = _slicedToArray(_useSelectionMultiple, 2),
      multiple = _useSelectionMultiple2[0],
      multipleActions = _useSelectionMultiple2[1];

  var _useSelectionSingle = useSelectionSingle(type === 'single' && selectionOptions || {}),
      _useSelectionSingle2 = _slicedToArray(_useSelectionSingle, 2),
      single = _useSelectionSingle2[0],
      singleActions = _useSelectionSingle2[1];

  var _ref3 = type === 'multiple' && [multiple, multipleActions] || type === 'single' && [single, singleActions] || [undefined, undefined],
      _ref4 = _slicedToArray(_ref3, 2),
      selected = _ref4[0],
      selectionActions = _ref4[1];

  var clearColumn = useClearTableColumn(_objectSpread({
    fixed: 'start'
  }, options));
  var selectionColumn = useMemo(function () {
    if (!enable) {
      return undefined;
    }

    var column = _objectSpread(_objectSpread({}, clearColumn), {}, {
      id: SELECTION_COLUMN_ID
    });

    if (isFunction(column.render)) {
      column.width = column.width || 48;
      return column;
    }

    if (!column.title) {
      column.title = function () {
        return React.createElement(TableSelectionHeader, _objectSpread({}, options));
      };
    }

    if (component === 'switch') {
      column.width = column.width || COLUMN_WIDTH_SWITCH;

      column.render = function (row, rowInfo) {
        var _rowInfo$selection = rowInfo.selection;
        _rowInfo$selection = _rowInfo$selection === void 0 ? {} : _rowInfo$selection;
        var selected = _rowInfo$selection.selected,
            toggle = _rowInfo$selection.toggle,
            _rowInfo$compProps = rowInfo.compProps,
            compProps = _rowInfo$compProps === void 0 ? {} : _rowInfo$compProps;
        return React.createElement(Switch, _objectSpread(_objectSpread({}, compProps), {}, {
          size: "sm",
          checked: selected,
          onChange: toggle
        }));
      };
    } else {
      switch (type) {
        case 'multiple':
          column.width = column.width || (dropdownMenu ? COLUMN_WIDTH_CHECKER_DROPDOWN : COLUMN_WIDTH_CHECKER);

          column.render = function (row, rowInfo) {
            var _rowInfo$selection2 = rowInfo.selection;
            _rowInfo$selection2 = _rowInfo$selection2 === void 0 ? {} : _rowInfo$selection2;
            var selected = _rowInfo$selection2.selected,
                toggle = _rowInfo$selection2.toggle,
                _rowInfo$compProps2 = rowInfo.compProps,
                compProps = _rowInfo$compProps2 === void 0 ? {} : _rowInfo$compProps2;
            return React.createElement(Checkbox, _objectSpread(_objectSpread({}, compProps), {}, {
              checked: selected,
              onChange: toggle
            }));
          };

          break;

        case 'single':
          column.width = column.width || COLUMN_WIDTH_CHECKER;

          column.render = function (row, rowInfo) {
            var _rowInfo$selection3 = rowInfo.selection;
            _rowInfo$selection3 = _rowInfo$selection3 === void 0 ? {} : _rowInfo$selection3;
            var selected = _rowInfo$selection3.selected,
                select = _rowInfo$selection3.select,
                _rowInfo$compProps3 = rowInfo.compProps,
                compProps = _rowInfo$compProps3 === void 0 ? {} : _rowInfo$compProps3;
            return React.createElement(Radio, _objectSpread(_objectSpread({}, compProps), {}, {
              checked: selected,
              onChange: select
            }));
          };

          break;
      }
    }

    column.minWidth = column.width;
    column.maxWidth = column.width;
    return column;
  }, [enable, type, component, dropdownMenu, selected, selectionActions, clearColumn]);
  return [selected, selectionActions, selectionColumn];
}
export var SelectionContext = createContext({
  selected: undefined,
  actions: undefined
});
export var useTableSelection = function useTableSelection() {
  return useContext(SelectionContext);
};